import { render } from "./EmergencyContactAdditional.vue?vue&type=template&id=a60e9322&ts=true"
import script from "./EmergencyContactAdditional.ts?vue&type=script&lang=ts&external"
export * from "./EmergencyContactAdditional.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__